import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { Project } from 'app/interfaces/project.model';
import { Detail } from 'app/interfaces/detail.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class ProjectService {
  constructor(private _http: HttpClient) {}

  fields() {
    return this._http.get<any>(`${environment.apiUrl}projects/Fields`);
  }

  save(project: Project) {
    if (project.Id) {
      return this._http.put<any>(`${environment.apiUrl}projects/update`, project, { withCredentials: true });
    } else {
      return this._http.post<any>(`${environment.apiUrl}projects/save`, project, { withCredentials: true });
    }
  }

  delete(project: Project) {
    return this._http.delete<any>(`${environment.apiUrl}projects/${project.Id}`, { withCredentials: true });
  }

  single(id): Observable<Project> {
    return this._http.get<any>(`${environment.apiUrl}projects/${id}`, { withCredentials: true });
  }

  getByDetail(detail: Detail): Observable<Array<Project>> {
    return this._http.get<any>(`${environment.apiUrl}projects/getByDetail?detail=${detail.Id}`);
  }

  getYears(nInThePast: number = 50, nInTheFuture: number = 50): number[] {
    const now = this.getCurrentYear();
    const min = now - nInThePast;
    const max = now + nInTheFuture;
    let years: number[] = [];

    for (let y = min; y <= max; y++) {
      years = [y, ...years];
    }

    return years;
  }

  getCurrentYear(): number {
    return new Date().getFullYear();
  }
}
